import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';

export const getAccountLedgerReport = (payload) => {
    const url = apiEndpoints.GET_ACCOUNT_LEDGER_REPORT_API.replace(':societyId', payload.societyId);
    return axiosInstance.get(url, {
        params: {
            accountCode: payload.accountCode,
            fromDate: payload.fromDate,
            toDate: payload.toDate,
        },
    });
};
